import { render } from "./video-upload.vue?vue&type=template&id=87fe6736&scoped=true"
import script from "./video-upload.vue?vue&type=script&lang=js"
export * from "./video-upload.vue?vue&type=script&lang=js"

import "./video-upload.vue?vue&type=style&index=0&id=87fe6736&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87fe6736"]])

export default __exports__